var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rack-item-details" },
    [
      _c("item-header", {
        attrs: { name: _vm.name, subtitle: _vm.subtitle, type: _vm.type }
      }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._l(_vm.item.properties, function(p) {
            return _c("item-property", {
              key: p.type,
              attrs: { name: p.name, values: p.values, mode: p.displayMode }
            })
          }),
          _vm._l(_vm.item.utilityMods, function(m) {
            return _c("item-mod", {
              key: m,
              attrs: { mod: m, type: "utility" }
            })
          }),
          _vm.item.requirements
            ? _c("separator", { attrs: { type: _vm.type } })
            : _vm._e(),
          _vm.item.requirements
            ? _c("item-requirement", {
                attrs: { requirements: _vm.item.requirements }
              })
            : _vm._e(),
          _vm.item.enchantMods
            ? _c("separator", { attrs: { type: _vm.type } })
            : _vm._e(),
          _vm._l(_vm.item.enchantMods, function(m) {
            return _c("item-mod", {
              key: m,
              attrs: { mod: m, type: "crafted" }
            })
          }),
          _vm.item.implicitMods
            ? _c("separator", { attrs: { type: _vm.type } })
            : _vm._e(),
          _vm._l(_vm.item.implicitMods, function(m) {
            return _c("item-mod", {
              key: m,
              attrs: { mod: m, type: "implicit" }
            })
          }),
          _vm.item.explicitMods || _vm.item.craftedMods
            ? _c("separator", { attrs: { type: _vm.type } })
            : _vm._e(),
          _vm._l(_vm.item.explicitMods, function(m) {
            return _c("item-mod", {
              key: m,
              attrs: { mod: m, type: "explicit" }
            })
          }),
          _vm._l(_vm.item.craftedMods, function(m) {
            return _c("item-mod", {
              key: m,
              attrs: { mod: m, type: "crafted" }
            })
          }),
          _vm.item.descrText
            ? _c(
                "div",
                { staticClass: "description" },
                [
                  _c("separator", { attrs: { type: _vm.type } }),
                  _c("span", [_vm._v(_vm._s(_vm.item.descrText))])
                ],
                1
              )
            : _vm._e(),
          _vm.item.flavourText
            ? _c("separator", { attrs: { type: _vm.type } })
            : _vm._e(),
          _vm._l(_vm.item.flavourText, function(t) {
            return _vm.item.flavourText
              ? _c("div", { staticClass: "flavour" }, [_vm._v(_vm._s(t))])
              : _vm._e()
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
/* hot reload */
if (module.hot) {
  var api = require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (module.hot.data) {
      require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js").rerender('2560f30b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    }
  }
}export { render, staticRenderFns }